/**
 * Route for `clickdealer-integration-via-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ClickdealerIntegrationViaApiPage } from "../features/clickdealer-integration-via-api/ClickdealerIntegrationViaApiPage";

export const clickdealerIntegrationViaApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/clickdealer-integration-via-api",
	component: ClickdealerIntegrationViaApiPage,
});

export default clickdealerIntegrationViaApiRoute;
